module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "option": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "swiper-wrapper-img b1"
  }, [_c('p', {
    staticClass: "t1 top"
  }, [_vm._v("OCEANBLUECLOUD")]), _vm._v(" "), _c('p', {
    staticClass: "t2"
  }, [_vm._v("Make Connection Easy")]), _vm._v(" "), _c('p', {
    staticClass: "t2"
  }, [_vm._v("Make Business Agile")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "swiper-wrapper-img b2"
  }, [_c('p', {
    staticClass: "t1 top1"
  }, [_vm._v("OCEANBLUECLOUD")]), _vm._v(" "), _c('p', {
    staticClass: "t3 top1"
  }, [_vm._v("High Performance")]), _vm._v(" "), _c('p', {
    staticClass: "t3"
  }, [_vm._v("Strong Security")]), _vm._v(" "), _c('p', {
    staticClass: "t3"
  }, [_vm._v("Flexible Deployment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "swiper-wrapper-img b3"
  }, [_vm._v("OCEANBLUECLOUD")])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ba67452","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/independent/Swiper.vue
// module id = 111
// module chunks = 49